import { FileOutlined } from '@ant-design/icons';
import { List } from 'antd-mobile';
import { ListItem } from 'antd-mobile/es/components/list/list-item';
import {
  CalendarOutlined,
  MailOutlined,
  PhoneOutlined,
  Text,
} from 'farmhub-ui-core';
import { useHistory } from 'react-router-dom';

import { CPopup, HeaderShare, Wrapper } from './styles';

export interface ContactPopupProps {
  visible: boolean;
  setVisible: (val: boolean) => void;
}

const ContactPopup = ({
  visible,
  setVisible,
}: ContactPopupProps): JSX.Element => {
  const history = useHistory();

  const supportMenuItems = [
    {
      name: 'SĐT: 0353 825 987',
      icon: <PhoneOutlined />,
      onClick: () => window.open(`tel: +84353825987`),
    },
    {
      name: 'Email: hoptacxaso@gmail.com',
      icon: <MailOutlined />,
      onClick: () => window.open(`mailto: hoptacxaso@gmail.com`),
    },
    {
      name: 'Gửi yêu cầu biểu mẫu',
      icon: <FileOutlined />,
      onClick: () => history.push('/help/form/create'),
    },
    {
      name: 'Đặt lịch hẹn',
      icon: <CalendarOutlined />,
      onClick: () => history.push('/help/meeting/create'),
    },
  ];

  return (
    <CPopup
      destroyOnClose
      bodyStyle={{
        borderTopLeftRadius: '18px',
        borderTopRightRadius: '18px',
        minHeight: 'fit-content',
        maxHeight: '-webkit-fill-available',
      }}
      visible={visible}
      onClose={() => {
        setVisible(false);
      }}
      onMaskClick={() => {
        setVisible(false);
      }}
    >
      <HeaderShare>
        <Text
          color="dark"
          size="sm"
          styles={{ fontSize: '14px !important', textAlign: 'center' }}
          weight="bold"
        >
          Liên hệ tư vấn
        </Text>
      </HeaderShare>
      <Wrapper>
        <List style={{ padding: '0px 0px' }}>
          {supportMenuItems.map(item => (
            <ListItem prefix={item.icon} onClick={item.onClick}>
              {item.name}
            </ListItem>
          ))}
        </List>
      </Wrapper>
    </CPopup>
  );
};
export default ContactPopup;
